import React from 'react';

import TextField from '../../../../forms/TextField';

export default function AdTitle() {
  return <TextField name="videoAd.adTitle" label="Ad Title" />;
}
